export const MONTHLY_CHALLENGE_KEY = "2026-06";

export const MONTHLY_CHALLENGE_XP = {
  participation: 110,
  ai80Bonus: 15,
};

export const MONTHLY_CHALLENGE = {
  key: MONTHLY_CHALLENGE_KEY,
  status: "active",
  isComingSoon: false,
  // INTERRUPTEUR RÉVÉLATION — mettre à true pour révéler le défi au public.
  // false = placeholder mystérieux affiché (défi caché avant l'annonce officielle).
  // true  = défi affiché normalement.
  // Révélé officiellement le 2026-06-01 (annonce Camille TikTok) — PROMPT_71.
  isRevealed: true,
  monthLabel: {
    fr: "Juin 2026",
    en: "June 2026",
  },
  label: {
    fr: "Défi du mois",
    en: "Monthly challenge",
  },
  title: {
    fr: "Verre cassé",
    en: "Broken Glass",
  },
  subtitle: {
    fr: "Découvre Verre cassé — un coloriage en mille éclats.",
    en: "Discover Broken Glass — a coloring in a thousand shards.",
  },
  description: {
    fr: "Imagine ton coloriage comme réfléchi dans un miroir brisé. Chaque éclat révèle un fragment de l'image, avec des contours nets et des reflets qui jouent avec la lumière. Un effet mosaïque qui fait briller chaque morceau.",
    en: "Imagine your coloring reflected in a broken mirror. Each shard reveals a fragment of the image, with sharp edges and reflections that play with light. A mosaic effect that makes every piece shine.",
  },
  editorial: {
    fr: "Camille te montre l'effet Verre cassé dans son tutoriel TikTok officiel. Divise ton dessin en éclats, joue avec les reflets, et laisse chaque fragment briller.",
    en: "Camille walks you through the Broken Glass effect in her official TikTok tutorial. Divide your drawing into shards, play with reflections, and let every fragment shine.",
  },
  bonusPrompt: {
    fr: "Partage ton Verre cassé sur le Mur !",
    en: "Share your Broken Glass on the Wall!",
  },
  cta: {
    fr: "Tenter le défi",
    en: "Take the challenge",
  },
  homeSubtitle: {
    fr: "Découvre Verre cassé — un coloriage en mille éclats.",
    en: "Discover Broken Glass — a coloring in a thousand shards.",
  },
  homeCta: {
    fr: "Voir le défi",
    en: "See the challenge",
  },
  paletteLabel: {
    fr: "Palette suggérée",
    en: "Suggested palette",
  },
  palette: [],
  // Image officielle du défi (à déposer dans frontend/public/images/challenges/)
  // Si absente au moment du merge : broken-image temporaire, non bloquant.
  image: "/images/challenges/juin-2026-verre-casse.png",
  // Tutoriel officiel par Camille (@colobycamille)
  tutorial: {
    label: {
      fr: "Tutoriel par Camille",
      en: "Tutorial by Camille",
    },
    tiktokUsername: "colobycamille",
    url: "https://www.tiktok.com/@colobycamille/video/7646381260444585236",
  },
  challengeTheme: "Verre cassé",
  winnerLabel: {
    fr: "Coup de cœur du défi",
    en: "Challenge favorite",
  },
  winnerByLevelLabel: {
    beginner: {
      fr: "Coup de cœur du défi — Débutant",
      en: "Challenge favorite - Beginner",
    },
    intermediate: {
      fr: "Coup de cœur du défi — Intermédiaire",
      en: "Challenge favorite - Intermediate",
    },
    expert: {
      fr: "Coup de cœur du défi — Expert",
      en: "Challenge favorite - Expert",
    },
  },
};

export function isMonthlyChallengeComingSoon(challenge = MONTHLY_CHALLENGE) {
  if (!challenge) return false;
  const status = String(challenge.status || "").trim().toLowerCase();
  return Boolean(challenge.isComingSoon) || status === "coming_soon";
}

export function monthlyChallengeText(textByLang, language = "fr") {
  return textByLang?.[language] || textByLang?.fr || textByLang?.en || "";
}
